/**
 * Slinky Theme JS
 * Cart drawer, scroll animations, smooth scroll
 */

(function () {
  'use strict';

  // --- Drawers (overlay) ---
  var sidePanel = document.getElementById('side-panel');
  var cartDrawer = document.getElementById('cart-drawer');
  var menuDrawer = document.getElementById('menu-drawer');
  var cartPanel = cartDrawer ? cartDrawer.querySelector('[data-cart-drawer-panel]') : null;
  var cartBackdrop = cartDrawer ? cartDrawer.querySelector('[data-cart-drawer-backdrop]') : null;
  var menuPanel = menuDrawer ? menuDrawer.querySelector('[data-menu-drawer-panel]') : null;
  var menuBackdrop = menuDrawer ? menuDrawer.querySelector('[data-menu-drawer-backdrop]') : null;
  var menuCloseBtn = menuDrawer ? menuDrawer.querySelector('[data-menu-drawer-close]') : null;
  var cartOpen = false;
  var menuOpen = false;

  function isMobile() {
    return window.innerWidth < 640;
  }

  function closedTransform() {
    return isMobile()
      ? 'translateY(calc(100vh + 100px))'
      : 'translateX(calc(100% + 18px))';
  }

  // --- Cart Drawer ---
  function openCartDrawer() {
    if (cartOpen) return;
    if (menuOpen) closeMenuDrawer();
    cartOpen = true;
    cartBackdrop.style.display = '';
    cartDrawer.style.pointerEvents = 'auto';
    cartPanel.style.transform = 'translate(0, 0)';
    cartBackdrop.style.opacity = '1';
    document.body.style.overflow = 'hidden';
    if (window.__lenis) window.__lenis.stop();
  }

  function closeCartDrawer() {
    if (!cartOpen) return;
    cartOpen = false;
    cartPanel.style.transform = closedTransform();
    cartBackdrop.style.opacity = '0';
    cartDrawer.style.pointerEvents = '';
    document.body.style.overflow = '';
    if (window.__lenis) window.__lenis.start();
    setTimeout(function () { cartBackdrop.style.display = 'none'; }, 300);
  }

  // --- Menu Drawer ---
  function openMenuDrawer() {
    if (menuOpen) return;
    if (cartOpen) closeCartDrawer();
    menuOpen = true;
    menuBackdrop.style.display = '';
    menuDrawer.style.pointerEvents = 'auto';
    menuPanel.style.transform = 'translate(0, 0)';
    menuBackdrop.style.opacity = '1';
    document.body.style.overflow = 'hidden';
    if (window.__lenis) window.__lenis.stop();
    if (menuCloseBtn) { menuCloseBtn.style.opacity = '1'; menuCloseBtn.style.pointerEvents = 'auto'; }
  }

  function closeMenuDrawer() {
    if (!menuOpen) return;
    menuOpen = false;
    menuPanel.style.transform = closedTransform();
    menuBackdrop.style.opacity = '0';
    menuDrawer.style.pointerEvents = '';
    document.body.style.overflow = '';
    if (window.__lenis) window.__lenis.start();
    if (menuCloseBtn) { menuCloseBtn.style.opacity = '0'; menuCloseBtn.style.pointerEvents = 'none'; }
    setTimeout(function () { menuBackdrop.style.display = 'none'; }, 300);
  }

  function closeAnyDrawer() {
    if (cartOpen) closeCartDrawer();
    if (menuOpen) closeMenuDrawer();
  }

  // React when bottom of site-wrap scrolls into view (side panel only)
  var pageEnd = document.getElementById('page-end');
  if (pageEnd && sidePanel) {
    var pageEndObserver = new IntersectionObserver(function (entries) {
      var footerVisible = entries[0].isIntersecting;
      sidePanel.style.transform = footerVisible ? 'translateX(-20rem)' : '';
    }, { threshold: 0 });
    pageEndObserver.observe(pageEnd);
  }

  // Cart toggle buttons
  document.querySelectorAll('[data-cart-drawer-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      cartOpen ? closeCartDrawer() : openCartDrawer();
    });
  });

  // Cart close buttons
  document.querySelectorAll('[data-cart-drawer-close]').forEach(function (btn) {
    btn.addEventListener('click', closeCartDrawer);
  });

  // Close cart on backdrop click
  if (cartBackdrop) {
    cartBackdrop.addEventListener('click', closeCartDrawer);
  }

  // Menu toggle buttons
  document.querySelectorAll('[data-menu-drawer-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      menuOpen ? closeMenuDrawer() : openMenuDrawer();
    });
  });

  // Menu close buttons
  document.querySelectorAll('[data-menu-drawer-close]').forEach(function (btn) {
    btn.addEventListener('click', closeMenuDrawer);
  });

  // Close menu on backdrop click
  if (menuBackdrop) {
    menuBackdrop.addEventListener('click', closeMenuDrawer);
  }

  // Close on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAnyDrawer();
  });

  // Auto-open drawer after successful Ajax Cart request
  document.addEventListener('liquid-ajax-cart:request-end', function (event) {
    var requestState = event.detail.requestState;
    if (requestState.requestType === 'add' && requestState.responseData && requestState.responseData.ok) {
      openCartDrawer();
    }

    if (
      cartOpen &&
      (requestState.requestType === 'change' || requestState.requestType === 'update') &&
      requestState.responseData &&
      requestState.responseData.ok
    ) {
      var active = document.activeElement;
      if (active && active.closest && active.closest('#cart-drawer')) {
        active.blur();
      }

      // Prevent drawer content from "jumping" after Ajax re-render.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          var scrollContainer =
            document.querySelector('#cart-drawer [data-ajax-cart-section-scroll]') ||
            document.querySelector('#cart-drawer [data-ajax-cart-section]');

          if (scrollContainer) {
            scrollContainer.scrollTop = 0;
          }
        });
      });
    }
  });

  // --- Scroll Animations (Intersection Observer) ---
  var animatedElements = document.querySelectorAll('[data-animate]');

  if (animatedElements.length > 0 && 'IntersectionObserver' in window) {
    // Add initial hidden state
    animatedElements.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transition = 'opacity 0.6s ease';
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    animatedElements.forEach(function (el) {
      observer.observe(el);
    });
  }

  // --- Smooth Scroll for anchor links ---
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

  // --- Side Panel ---
  if (sidePanel) {
    var closeBtn = document.getElementById('side-panel-close');

    // Restore dismissed state from sessionStorage
    if (sessionStorage.getItem('side-panel-dismissed') === '1') {
      sidePanel.style.display = 'none';
      sidePanel.setAttribute('data-dismissed', 'true');
    }

    // Close button dismisses the entire panel for the session
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        sidePanel.style.display = 'none';
        sidePanel.setAttribute('data-dismissed', 'true');
        sessionStorage.setItem('side-panel-dismissed', '1');
      });
    }
  }
})();
